import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input"]

  dragover(e) {
    e.preventDefault()
    this.element.classList.add("dropzone-active")
  }

  dragleave(e) {
    e.preventDefault()
    this.element.classList.remove("dropzone-active")
  }

  drop(e) {
    e.preventDefault()
    this.element.classList.remove("dropzone-active")

    const files = e.dataTransfer.files
    if (files.length > 0 && this.hasInputTarget) {
      this.inputTarget.files = files
      this.submit()
    }
  }

  submit() {
    this.element.submit()
  }
}
